<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickSave">新增</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickBatchDelete">批量删除</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button type="primary" @click="clickShow(row)" style="padding: 5px 5px 6px;">查看详情</Button>
					<Button type="primary" @click="clickUpdate(row)" style="padding: 5px 5px 6px;">编辑</Button>
					<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>表号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入表号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div v-if="showType=='show'||showType=='save'">
				<span>身份证号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.idCard" />
			</div>
			<div>
				<span>姓名</span>
				<Input :readonly="showType=='show'" v-model="currentRow.name" />
			</div>
			<div>
				<span>电话</span>
				<Input :readonly="showType=='show'" v-model="currentRow.phone" />
			</div>
			<div>
				<span>性别</span>
				<Input :readonly="showType=='show'" v-model="currentRow.gender" type="number" />
			</div>
			<div>
				<span>备注</span>
				<Input :readonly="showType=='show'" v-model="currentRow.remark" />
			</div>
			<div v-if="showType=='show'">
				<span>创建时间</span>
				<Input readonly v-model="currentRow.createTime" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='save'||showType=='update'" :loading="submitLoading" type="info" size="large"
					long @click="submitUpdate">立即提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "customer_manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "身份证号",
						width: 200,
						key: "idCard",
						align: "center"
					},
					{
						title: "姓名",
						width: 100,
						key: "name",
						align: "center"
					},
					{
						title: "电话",
						width: 200,
						key: "phone",
						align: "center"
					},
					{
						title: "性别",
						width: 100,
						key: "gender",
						align: "center"
					},
					{
						title: "备注",
						width: 100,
						key: "remark",
						align: "center"
					},
					{
						title: "创建时间",
						width: 200,
						key: "createTime",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.createTime)
								)
							);
						}
					},
					{
						title: "操作",
						fixed: 'right',
						width: 200,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				selection: [],
				currentRow: {},
				data1: [],
				loading: false,
				submitLoading: false,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindCompany: false,
				bindCompanyNum: '',
				showType: 'show',
				showTitle: '详情',
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickBatchDelete() {
				let that = this;
				if (that.selection.length == 0) {
					that.$Notice.info({
						title: "提示",
						desc: "请选择数据"
					});
					return;
				}

				let idCardArray = [];
				for (let i in that.selection) {
					let idCard = that.selection[i].idCard;
					idCardArray.push(idCard);
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认批量删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/customer/delete",
							type: "post",
							data: {
								idCard: idCardArray.join(',')
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			clickShow(row) {
				this.currentRow = row;
				this.showType = 'show';
				this.showTitle = '详情';
				this.showDialog = true;
			},
			clickSave() {
				this.currentRow = {};
				this.showType = 'save';
				this.showTitle = '新增';
				this.showDialog = true;
			},
			clickUpdate(row) {
				this.currentRow = row;
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			submitUpdate() {
				let that = this;
				that.submitLoading = true;
				delete that.currentRow.createTime;
				$.ajax({
					url: "/api/meter/admin/customer/" + that.showType,
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickDelete(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/customer/delete",
							type: "post",
							data: {
								idCard: row.idCard
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									that.getDataList();
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/customer/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
